import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ValidatorFn, Validators} from '@angular/forms';
import {ConfirmedCredentialFormFieldComponent} from '@aviary/forms/fields/confirmed-credential-form-field/confirmed-credential-form-field.component';
import {ExtendedFormControl} from '@aviary/forms/extensions/extended-form-control/extended-form-control';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {getExtendedControlFrom} from '@aviary/forms/form.helpers';
import {CommonValidators, MAXIMUM_PIN_LENGTH} from '@aviary/store/common/common.validators';

@Component({
  selector: 'px-confirmed-pin-form-field',
  template: `
    <mx-confirmed-credential-form-field [fieldName]="fieldName" [formGroup]="formGroup" [credentialLabel]="pinLabel"
                                        [confirmationLabel]="confirmationLabel" mismatchErrorMessage="PINs do not match."
                                        [maxLength]="maximumPinLength" inputMode="numeric"/>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ConfirmedCredentialFormFieldComponent]
})
export class ConfirmedPinFormFieldComponent implements OnInit, OnDestroy {
  @Input({required: true}) public fieldName: string;
  @Input({required: true}) public formGroup: ExtendedFormGroup;
  @Input() public pinLabel: string = 'PIN';
  @Input() public confirmationLabel: string = 'Confirm PIN';

  public readonly maximumPinLength: number = MAXIMUM_PIN_LENGTH;

  private readonly requiredValidator: ValidatorFn = Validators.required;
  private readonly pinValidator: ValidatorFn = CommonValidators.pinValidator;
  private pinControl: ExtendedFormControl;

  public ngOnInit(): void {
    this.pinControl = getExtendedControlFrom(this.formGroup, this.fieldName);
    this.pinControl.addValidators([this.requiredValidator, this.pinValidator]);
    this.pinControl.updateValueAndValidity({emitEvent: false});
  }

  public ngOnDestroy(): void {
    this.pinControl.removeValidators([this.requiredValidator, this.pinValidator]);
    this.pinControl.updateValueAndValidity({emitEvent: false});
  }
}
